import * as React from 'react';
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  createTrainingCertificateAsync,
  getAllTrainingCertificatesAsync,
} from './CertificationStore/CertificationStoreSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const BUSINESS_VERTICALS = [
  { value: 'atheneum', label: 'Atheneum' },
  { value: 'iimtt', label: 'IIMTT' },
];

const initialFormState = {
  studentRegistrationNum: '',
  studentName: '',
  trainingCentre: '',
  awardDate: '',
  awardClassification: '',
  courseType: '',
  businessVertical: '',
};

const AddTrainingCertificate = () => {
  const [form, setForm] = React.useState(initialFormState);
  const dispatch = useDispatch();

  const { createLoading } = useSelector((state) => {
    const { trainingCertificateReducer } = state;

    return {
      createLoading:
        trainingCertificateReducer && trainingCertificateReducer.createLoading,
    };
  });

  const handleChange = (field) => (e) => {
    const value = e.target.value;

    setForm((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'businessVertical' && value === 'atheneum'
        ? { trainingCentre: '' }
        : {}),
    }));
  };

  const isFormValid = () =>
    form.studentRegistrationNum &&
    form.studentName &&
    form.awardDate &&
    form.awardClassification &&
    form.courseType &&
    form.businessVertical;

  const addCertificate = async () => {
    if (!isFormValid()) {
      toast.error('Please fill all required fields.');
      return;
    }

    try {
      const payload = { ...form };
      if (!payload.trainingCentre) delete payload.trainingCentre;

      dispatch(createTrainingCertificateAsync(payload))
        .unwrap()
        .then(() => {
          dispatch(getAllTrainingCertificatesAsync({}));
          toast.success('Certificate was added successfully.');
          setForm(initialFormState);
        })
        .catch((error) => {
          toast.error(
            (error && error.message) || 'Certificate could not be added.'
          );
        });
    } catch (error) {
      toast.error('Certificate could not be added.');
    }
  };

  return (
    <Box sx={style}>
      <Box>
        <Typography>Add a Training Certificate</Typography>
        <Box alignItems="center">
          <Box mt={2} />
          <Box>
            <TextField
              fullWidth
              label="Student Registration Num"
              variant="outlined"
              size="small"
              value={form.studentRegistrationNum}
              onChange={handleChange('studentRegistrationNum')}
            />
          </Box>

          <Box mt={2} />
          <Box>
            <TextField
              fullWidth
              label="Student Name"
              variant="outlined"
              size="small"
              value={form.studentName}
              onChange={handleChange('studentName')}
            />
          </Box>
          <Box mt={2} />
          <Box>
            <TextField
              select
              fullWidth
              label="Business Vertical"
              variant="outlined"
              size="small"
              value={form.businessVertical}
              onChange={handleChange('businessVertical')}>
              {BUSINESS_VERTICALS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          {form.businessVertical !== 'atheneum' && (
            <>
              <Box mt={2} />
              <Box>
                <TextField
                  fullWidth
                  label="Training Centre"
                  variant="outlined"
                  size="small"
                  value={form.trainingCentre}
                  onChange={handleChange('trainingCentre')}
                />
              </Box>
            </>
          )}

          <Box mt={2} />
          <Box>
            <TextField
              fullWidth
              label="Award Date"
              type="date"
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={form.awardDate}
              onChange={handleChange('awardDate')}
            />
          </Box>

          <Box mt={2} />
          <Box>
            <TextField
              fullWidth
              label="Award Classification"
              variant="outlined"
              size="small"
              value={form.awardClassification}
              onChange={handleChange('awardClassification')}
            />
          </Box>

          <Box mt={2} />
          <Box>
            <TextField
              fullWidth
              label="Course Type"
              variant="outlined"
              size="small"
              value={form.courseType}
              onChange={handleChange('courseType')}
            />
          </Box>
        </Box>

        <Box my={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={addCertificate}
            disabled={createLoading}>
            {createLoading ? 'Adding...' : 'Add Certificate'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddTrainingCertificate;
